import { TableCell, TableRow, Tooltip } from '@mui/material'
import React from 'react'
import SupplyOrderItemAgree from '../../../../supply/supplyOrder/view/items/fields/SupplyOrderItemAgree'
// import { unitMeasureShortText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'
import AgreeDirectorButton from '../../forms/agreeDirector/AgreeDirectorButton'
import AgreeAccountantButton from '../../forms/agreeAccountant/AgreeAccountantButton'
import AgreeIcon from '../../../../UI/agree/AgreeIcon'
import Person4Icon from '@mui/icons-material/Person4';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AgreeIcons from '../../../../UI/agree/AgreeIcons'
import UnitMeasureShortText from '../../../../unitMeasure/UnitMeasureShortText'

const WriteOffActItemShort = ({ writeOffActItem, index, checked, setChecked }) => {

  return (
    <TableRow>
        <TableCell align='center'>
            <Tooltip title={`ID ${writeOffActItem.id}`}>
                {
                    index + 1
                }
            </Tooltip>
        </TableCell>
        <TableCell align='center'>
            {
				writeOffActItem.name
			}
        </TableCell>
        <TableCell align='center'>
            <div className='supplyCounts'>
                <p>
                    <Tooltip title='Всього'>
                        {writeOffActItem.count}
                    </Tooltip>
                </p>
                {/* <p>
                    {
                        unitMeasureShortText[writeOffActItem.unitMeasure]
                    }
                </p> */}
                <UnitMeasureShortText unitMeasure={writeOffActItem.unitMeasure} />
            </div>
        </TableCell>
        <TableCell align='center'>
            {/* <SupplyOrderItemAgree
                supplyOrderItem={writeOffActItem}
            /> */}
            <AgreeIcons>
                <AgreeIcon 
                    ico={<Person4Icon />}
                    text={'Погодження директором'}
                    value={writeOffActItem.isAgreeDirector}
                    disagreeText={writeOffActItem.disagreeDirectorText}
                />
                <AgreeIcon 
                    ico={<PointOfSaleIcon />}
                    text={'Погодження бухгалтером'}
                    value={writeOffActItem.isAgreeAccountant}
                    disagreeText={writeOffActItem.disagreeAccountantText}
                />
            </AgreeIcons>
        </TableCell>
    </TableRow>
  )
}

export default WriteOffActItemShort